/**
 * AddressPage — manage delivery addresses (hostel, block, room).
 * Real address CRUD needs login + the Maps integration (both later). Shell now.
 */

import { MapPin } from 'lucide-react';
import { Container, PageHeader } from '@/components/layout/Container';
import { EmptyState, Button } from '@/components/ui';

export function AddressPage() {
  return (
    <Container>
      <PageHeader title="Saved Addresses" subtitle="Where should we deliver?" />
      <EmptyState
        icon={MapPin}
        title="No saved addresses"
        description="Add your hostel, block and room number for faster checkout. Address management and map pinning arrive with the Maps integration."
        action={<Button>Add an address</Button>}
      />
    </Container>
  );
}

export default AddressPage;
